import { useSearchParams } from "react-router";

import { Orderings, useTableData } from "@nens/react/hooks";

export type UseRanaTableDataOptions = {
  keyAddon: string;
  initialOrderings?: Orderings;
  initialSearchString?: string;
  initialSearchField?: string;
  initialPage?: number;
  initialPageSize?: number;
  hasSearchParams?: boolean;
};

// This hook is a wrapper around the useTableData hook from @nens/react/hooks.
// It adds support for storing the table state in the URL search params,
// so that the table state can be shared via URL and restored on page reload.
// The keyAddon is used to create a unique key for the table state in the search params,
// so that multiple tables on the same page can have their own state.
export function useRanaTableData({
  keyAddon,
  hasSearchParams = true,
  ...rest
}: UseRanaTableDataOptions) {
  const [searchParams, setSearchParams] = useSearchParams();

  return useTableData({
    ...rest,
    hasSearchParams,
    searchParams,
    setSearchParams,
    keyAddon,
  });
}
